import { isNonEmptyArray } from "@cayuse/shared-react.utils.type-checks";

import { API_AWARD_FEED, API_SUBAWARD, API_AWARD, API_SUBAWARD_FEED, API_SUBAWARD_SUMMARY } from "globals/constants";
import { encodeSearchTerms, spUrl } from "utils";
import { buildSearchParams, request, save, put } from "utils/proxy";


export const subaward = {
	create: (awardId, body, options) => save(spUrl(`${API_AWARD}/${awardId}/sub-awards?strict=true`), body, options),

	createOrCopy: (body, options) => save(spUrl(`${API_SUBAWARD}?strict=true`), body, options),

	get: (subawardId, options) => request(spUrl(`${API_SUBAWARD}/${subawardId}`), options),

	getList: (awardId, searchParams, options) => {
		const params = {
			page: parseInt(searchParams.page),
			size: parseInt(searchParams.size),
			search: searchParams.search ? encodeSearchTerms(searchParams.search) : "",
			fields: isNonEmptyArray(searchParams.fields) ? searchParams.fields.join(",") : "",
		};

		const url = awardId ?
      `${API_SUBAWARD_FEED}${buildSearchParams(params)}&awardId=${awardId}` :
      `${API_SUBAWARD_FEED}${buildSearchParams(params)}`;

		return request(spUrl(url), options);
	},

	getSummary: (searchParams = { groupBy: "status" }, options) =>
		request(spUrl(`${API_SUBAWARD_SUMMARY}${buildSearchParams(searchParams)}`), options),

	getValues: (awardId,  subawardId, options) => request(spUrl(`${API_SUBAWARD_FEED}/${subawardId}`), options),

	getStatus: (subawardId, options) => request(spUrl(`${API_SUBAWARD}/${subawardId}/status/flow`), options),

	saveStatus: (subawardId, body, options) => save(spUrl(`${API_SUBAWARD}/${subawardId}/status`), body, options),

	updateStatus: (subawardId, body, options) => put(spUrl(`${API_SUBAWARD}/${subawardId}/status`), body, options),
};
